import { Box, Button, Typography } from "@mui/material";
import { RouteLiveGuidanceType } from "../../../../types/types";

const labels: Record<RouteLiveGuidanceType["status"], string> = {
    NO_ROUTE: "Sem rota programada neste horário",
    IN_ROUTE: "Dentro do corredor previsto",
    VERIFYING: "Saída do corredor em verificação",
    POSSIBLE_DEVIATION: "Possível desvio de rota",
    NO_RECENT_POSITION: "Sem posição recente para avaliar a rota",
    UNAVAILABLE: "Não foi possível verificar a rota agora",
};

const colors: Record<RouteLiveGuidanceType["status"], string> = {
    NO_ROUTE: "#64748b",
    IN_ROUTE: "#15803d",
    VERIFYING: "#b45309",
    POSSIBLE_DEVIATION: "#b91c1c",
    NO_RECENT_POSITION: "#64748b",
    UNAVAILABLE: "#64748b",
};

type Props = {
    guidance: RouteLiveGuidanceType | null | undefined;
    routeVisible: boolean;
    routeLoading: boolean;
    routeAvailable: boolean;
    routeError: string | null;
    onToggleRoute: () => void;
};

const RouteLiveGuidance = ({ guidance, routeVisible, routeLoading, routeAvailable, routeError, onToggleRoute }: Props) => {
    if (!guidance) return null;
    const statusLabel = guidance.status === "VERIFYING"
        ? `${labels.VERIFYING} (${guidance.outsideSequence}/3)`
        : labels[guidance.status];
    return (
        <Box className="tw-px-3.5 tw-py-2" role="status" aria-live="polite">
            <Typography sx={{ fontSize: 10.5, fontWeight: 800, color: colors[guidance.status] }}>
                ROTA PREVISTA · {statusLabel}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mt: 0.5 }}>
                <Typography noWrap title={guidance.routeName ?? ""} sx={{ minWidth: 0, fontSize: 10.5, color: "text.secondary" }}>
                    {guidance.routeName}
                </Typography>
                {guidance.routeId != null && (
                    <Button size="small" variant="outlined" onClick={onToggleRoute}
                        disabled={!routeAvailable || routeLoading} aria-pressed={routeVisible}
                        sx={{ flex: "none", fontSize: 10, py: 0.25, px: 1, minWidth: 0, textTransform: "none" }}>
                        {routeLoading ? "Carregando..." : routeVisible ? "Ocultar rota" : "Visualizar rota"}
                    </Button>
                )}
            </Box>
            {routeError && (
                <Typography role="alert" sx={{ fontSize: 10, color: "error.main", mt: 0.5 }}>
                    {routeError}
                </Typography>
            )}
            {guidance.status === "POSSIBLE_DEVIATION" && (
                <Typography sx={{ fontSize: 9.5, color: "text.secondary", mt: 0.25 }}>
                    Indício ao vivo; a confirmação ocorre após o turno.
                </Typography>
            )}
        </Box>
    );
};

export default RouteLiveGuidance;
